"use client";

import { Check, Copy, Linkedin, Mail } from "lucide-react";
import { useState } from "react";

interface ArticleShareActionsProps {
  title: string;
  shareUrl: string;
}

export function ArticleShareActions({
  title,
  shareUrl,
}: ArticleShareActionsProps) {
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const actionClassName =
    "inline-flex h-10 w-10 items-center justify-center border border-white/15 text-white/70 transition-colors hover:border-white/40 hover:text-white";

  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={handleCopy}
        className={actionClassName}
        aria-label={copied ? "Link copied" : "Copy article link"}
      >
        {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
      </button>

      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className={actionClassName}
        aria-label="Share on LinkedIn"
      >
        <Linkedin className="h-4 w-4" />
      </a>

      <a
        href={`mailto:?subject=${encodedTitle}&body=${encodedUrl}`}
        className={actionClassName}
        aria-label="Share by email"
      >
        <Mail className="h-4 w-4" />
      </a>
    </div>
  );
}
